import { v4 as uuid } from "uuid";

interface BuildAdTagOptions {
  accountId?: string;
  duration?: number;
}

/**
 * Builds a Google Ad Manager (GAM) ad tag URL for video ads
 *
 * @param adUnit - The ad unit path (e.g., "player_video_midroll")
 * @param options - Configuration options
 * @param options.accountId - The GAM network code (defaults to 23325224050)
 * @param options.duration - Duration of the video ad is being requested for
 * @returns The complete ad tag URL
 */
export function buildAdTag(adUnit: string, opts?: BuildAdTagOptions): string {
  const params = new URLSearchParams({
    ad_type: "video",
    iu: `/${opts?.accountId ?? "23325224050"}/${adUnit}`,
    tfcd: "0",
    npa: "0",
    sz: "1280x720",
    gdfp_req: "1",
    unviewed_position_start: "1",
    output: "vast",
    env: "vp",
    impl: "s",
    correlator: uuid(),
    vad_type: "linear",
    documentation_url: window.location.href,
  });

  if (opts?.duration) {
    params.set("vid_d", opts.duration.toString());
  }

  console.log("ad tag with:", params.toString());

  return `https://pubads.g.doubleclick.net/gampad/ads?${params.toString()}`;
}
